<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="400px")
    v-card
      v-card-title.px-5.pb-0.white.lighten-3
        v-row(no-gutters justify="center")
          v-col(cols="6")
            p.mb-2.s1.text-center {{ $t('customize_avatar') }}
            intel-avatar.ma-2(:code="codeAvatar" :id="user")

      v-card-text.pa-0
        v-card.pa-4
          p.label.basic600--text.text-uppercase {{ $t('gender') }}
          v-radio-group.mt-0(v-model="gender" row)
            v-row(no-gutters)
              v-col
                v-radio(label="Male" value="M")
              v-col
                v-radio(label="Female" value="F")
          template(v-if="")
            p.mb-1.label.basic600--text.text-uppercase {{ $t('hair_hat') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="topType" :items="itemTopType" label="Hair / Hat" item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase(v-if="!hairColExclude.includes(topType) && !topColExclude.includes(topType)") {{ $t('hair_color') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-if="!hairColExclude.includes(topType) && !topColExclude.includes(topType)" v-model="hairColor" :items='items.hairColor' label='Hair color' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase(v-if="hairColExclude.includes(topType) && !topColExclude.includes(topType)") {{ $t('hat_color') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-if="hairColExclude.includes(topType) && !topColExclude.includes(topType)" v-model="hatColor" :items='items.hatColor' label='Hat color' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase {{ $t('eyes') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="eyeType" :items='items.eyeType' label='Eyes' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase {{ $t('eyebrows') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="eyebrowType" :items='items.eyebrowType' label='Eyebrows' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase {{ $t('mouth') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="mouthType" :items='items.mouthType' label='Mouth' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase {{ $t('accessories') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="accessoriesType" :items='items.accessoriesType' label='Accessories' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase(v-if="gender === 'M'") {{ $t('facial_hair') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-if="gender === 'M'" v-model="facialHairType" :items='items.facialHairType' label='Facial hair' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase(v-if="gender === 'M' && facialHairType !== '0'") {{ $t('facial_hair_color') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-if="gender === 'M' && facialHairType !== '0'" v-model="facialHairColor" :items='items.facialHairColor' label='Facial hair color' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase {{ $t('skin_color') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="skinColor" :items='items.skinColor' label='Skin color' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase {{ $t('clothe') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-model="clotheType" :items='items.clotheType' label='Clothe' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase(v-if="clotheType !== '0' && clotheType !== '1'") {{ $t('clothe_color') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-if="clotheType !== '0' && clotheType !== '1'" v-model="clotheColor" :items='items.clotheColor' label='Clothe color' item-value="value" item-text="name" outlined dense)
            p.mb-1.label.basic600--text.text-uppercase(v-if="clotheType === '3'" v-model="graphicType") {{ $t('graphic_type') }}
            v-select.p1.basic500--text.pt-2( solo flat background-color="basic200"    height="40" v-if="clotheType === '3'" v-model="graphicType" :items='items.graphicType' label='Graphic type' item-value="value" item-text="name" outlined dense)
      v-divider
      v-card-actions
        v-spacer
        v-btn.button-AA-medium(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.mr-2.white--text.button-AA-medium(color='info500' depressed height=32 :loading="loading" @click="clickSave")
          div {{ $t('save') }}

</template>

<script>
import { mapActions } from 'vuex'
import IntelAvatar from '@/components/IntelAvatar.vue'
export default {
  name: 'ChangeAvatar',
  components: { IntelAvatar },
  props: ['open', 'code', 'user'],
  data: () => ({
    loading: false,
    gender: null,
    topType: '0',
    hairColor: '0',
    hatColor: '0',
    eyeType: '2',
    eyebrowType: '2',
    mouthType: '1',
    accessoriesType: '0',
    facialHairType: '0',
    facialHairColor: '0',
    skinColor: '2',
    clotheType: '0',
    clotheColor: '0',
    graphicType: '0',
    topColExclude: ['0', '1', '29'],
    hairColExclude: ['2', '3', '4', '5', '6', '24'],
    items: {
      topTypeM : [
        { name: 'NoHair', value: '0' },// no hat no hair
        { name: 'Hat', value: '1' }, // no hat no hair
        { name: 'Turban', value: '2' },// HatC
        { name: 'WinterHat1', value: '3' },// HatC
        { name: 'WinterHat2', value: '4' },// HatC
        { name: 'WinterHat3', value: '5' },// HatC
        { name: 'WinterHat4', value: '6' },// HatC
        { name: 'LongHairBun', value: '7' },
        { name: 'LongHairDreads', value: '8' },
        { name: 'LongHairFro', value: '9' },
        { name: 'LongHairFroBand', value: '10' },
        { name: 'LongHairNotTooLong', value: '11' },
        { name: 'LongHairStraightStrand', value: '12' },
        { name: 'ShortHairDreads01', value: '13' },
        { name: 'ShortHairDreads02', value: '14' },
        { name: 'ShortHairFrizzle', value: '15' },
        { name: 'ShortHairShaggyMullet', value: '16' },
        { name: 'ShortHairShortCurly', value: '17' },
        { name: 'ShortHairShortFlat', value: '18' },
        { name: 'ShortHairShortRound', value: '19' },
        { name: 'ShortHairShortWaved', value: '20' },
        { name: 'ShortHairSides', value: '21' },
        { name: 'ShortHairTheCaesar', value: '22' },
        { name: 'ShortHairTheCaesarSidePart', value: '23' }
      ],
      topTypeF : [ //no facial hair + color
        { name: 'Hijab', value: '24' }, // HatC
        { name: 'LongHairBigHair', value: '25' },
        { name: 'LongHairBob', value: '26' },
        { name: 'LongHairCurly', value: '27' },
        { name: 'LongHairCurvy', value: '28' },
        { name: 'LongHairFrida', value: '29' },// no hat no hair
        { name: 'LongHairMiaWallace', value: '30' },
        { name: 'LongHairStraight', value: '31' },
        { name: 'LongHairStraight2', value: '32' },
        { name: 'WinterHat2', value: '4' },// HatC
        { name: 'LongHairBun', value: '7' },
        { name: 'LongHairFro', value: '9' },
        { name: 'LongHairFroBand', value: '10' },
        { name: 'LongHairNotTooLong', value: '11' },
        { name: 'LongHairStraightStrand', value: '12' },
        { name: 'ShortHairShaggyMullet', value: '16' },
        { name: 'ShortHairTheCaesar', value: '22' }
      ],
      hairColor: [
        { name: 'Black', value: '0' },
        { name: 'Auburn', value: '1' },
        { name: 'Blonde', value: '2' },
        { name: 'BlondeGolden', value: '3' },
        { name: 'Brown', value: '4' },
        { name: 'BrownDark', value: '5' },
        { name: 'PastelPink', value: '6' },
        { name: 'Platinum', value: '7' },
        { name: 'Red', value: '8' },
        { name: 'SilverGray', value: '9' }
      ],
      hatColor: [
        { name: 'Black', value: '0' },
        { name: 'Blue01', value: '1' },
        { name: 'Blue02', value: '2' },
        { name: 'Blue03', value: '3' },
        { name: 'Gray01', value: '4' },
        { name: 'Gray02', value: '5' },
        { name: 'Heather', value: '6' },
        { name: 'PastelBlue', value: '7' },
        { name: 'PastelGreen', value: '8' },
        { name: 'PastelOrange', value: '9' },
        { name: 'PastelRed', value: '10' },
        { name: 'PastelYellow', value: '11' },
        { name: 'Pink', value: '12' },
        { name: 'Red', value: '13' },
        { name: 'White', value: '14' }
      ],
      eyeType: [
        { name: 'Close', value: '0' },
        { name: 'Cry', value: '1' },
        { name: 'Default', value: '2' },
        { name: 'Dizzy', value: '3' },
        { name: 'EyeRoll', value: '4' },
        { name: 'Happy', value: '5' },
        { name: 'Hearts', value: '6' },
        { name: 'Side', value: '7' },
        { name: 'Squint', value: '8' },
        { name: 'Surprised', value: '9' },
        { name: 'Wink', value: '10' },
        { name: 'WinkWacky', value: '11' }
      ],
      eyebrowType: [
        { name: 'Angry', value: '0' },
        { name: 'AngryNatural', value: '1' },
        { name: 'Default', value: '2' },
        { name: 'DefaultNatural', value: '3' },
        { name: 'FlatNatural', value: '4' },
        { name: 'RaisedExcited', value: '5' },
        { name: 'RaisedExcitedNatural', value: '6' },
        { name: 'SadConcerned', value: '7' },
        { name: 'SadConcernedNatural', value: '8' },
        { name: 'UnibrowNatural', value: '9' },
        { name: 'UpDown', value: '10' },
        { name: 'UpDownNatural', value: '11' }
      ],
      mouthType: [
        { name: 'Concerned', value: '0' },
        { name: 'Default', value: '1' },
        { name: 'Disbelief', value: '2' },
        { name: 'Eating', value: '3' },
        { name: 'Grimace', value: '4' },
        { name: 'Sad', value: '5' },
        { name: 'ScreamOpen', value: '6' },
        { name: 'Serious', value: '7' },
        { name: 'Smile', value: '8' },
        { name: 'Tongue', value: '9' },
        { name: 'Twinkle', value: '10' }
      ],
      accessoriesType: [
        { name: 'Blank', value: '0' },
        { name: 'Kurt', value: '1' },
        { name: 'Prescription01', value: '2' },
        { name: 'Prescription02', value: '3' },
        { name: 'Round', value: '4' },
        { name: 'Sunglasses', value: '5' },
        { name: 'Wayfarers', value: '6' }
      ],
      facialHairType: [
        { name: 'Blank', value: '0' }, // No FHair color
        { name: 'BeardMedium', value: '1' },
        { name: 'BeardLight', value: '2' },
        { name: 'BeardMajestic', value: '3' },
        { name: 'MoustacheFancy', value: '4' },
        { name: 'MoustacheMagnum', value: '5' }
      ],
      facialHairColor: [
        { name: 'Black', value: '0' },
        { name: 'Auburn', value: '1' },
        { name: 'Blonde', value: '2' },
        { name: 'BlondeGolden', value: '3' },
        { name: 'Brown', value: '4' },
        { name: 'BrownDark', value: '5' },
        { name: 'PastelPink', value: '6' },
        { name: 'Platinum', value: '7' },
        { name: 'Red', value: '8' },
        { name: 'SilverGray', value: '9' }
      ],
      skinColor: [
        { name: 'Tanned', value: '0' },
        { name: 'Yellow', value: '1' },
        { name: 'Pale', value: '2' },
        { name: 'Light', value: '3' },
        { name: 'Brown', value: '4' },
        { name: 'DarkBrown', value: '5' },
        { name: 'Black', value: '6' }
      ],
      clotheType: [
        { name: 'BlazerShirt', value: '0' }, //no color
        { name: 'BlazerSweater', value: '1' }, //no color
        { name: 'CollarSweater', value: '2' }, 
        { name: 'GraphicShirt', value: '3' }, //color & graph
        { name: 'Hoodie', value: '4' },
        { name: 'Overall', value: '5' },
        { name: 'ShirtCrewNeck', value: '6' },
        { name: 'ShirtScoopNeck', value: '7' },
        { name: 'ShirtVNeck', value: '8' }
      ],
      clotheColor: [
        { name: 'Black', value: '0' },
        { name: 'Blue01', value: '1' },
        { name: 'Blue02', value: '2' },
        { name: 'Blue03', value: '3' },
        { name: 'Gray01', value: '4' },
        { name: 'Gray02', value: '5' },
        { name: 'Heather', value: '6' },
        { name: 'PastelBlue', value: '7' },
        { name: 'PastelGreen', value: '8' },
        { name: 'PastelOrange', value: '9' },
        { name: 'PastelRed', value: '10' },
        { name: 'PastelYellow', value: '11' },
        { name: 'Pink', value: '12' },
        { name: 'Red', value: '13' },
        { name: 'White', value: '14' }
      ],
      graphicType: [
        { name: 'Bat', value: '0' },
        { name: 'Cumbia', value: '1' },
        { name: 'Deer', value: '2' },
        { name: 'Diamond', value: '3' },
        { name: 'Hola', value: '4' },
        { name: 'Pizza', value: '5' },
        { name: 'Resist', value: '6' },
        { name: 'Selena', value: '7' },
        { name: 'Bear', value: '8' },
        { name: 'SkullOutline', value: '9' },
        { name: 'Skull', value: '10' }
      ],
    }
    
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    itemTopType() {
      if(this.gender === 'F') {
        return this.items.topTypeF
      } else {
        return this.items.topTypeM
      }
    },
    codeAvatar () {
      let a = 'a'+this.topType
      let b = '-b'+this.eyeType
      let c = '-c'+this.eyebrowType
      let d = '-d'+this.mouthType
      let e = '-e'+this.accessoriesType
      let f = '-f'+this.skinColor
      let g = '-g'+this.clotheType
      let h = ''
      let i = ''
      let j = ''
      let k = ''
      let l = ''
      let m = ''
      let n = '-n'+this.gender
        
      if (!this.topColExclude.includes(this.topType)) {
        if (!this.hairColExclude.includes(this.topType)) {
          h = '-h'+this.hairColor
        } else {
          i = '-i'+this.hatColor
        }
      }
      if (this.gender === 'M') {
        j = '-j'+this.facialHairType
        if (this.facialHairType !== '0') {
          k = '-k'+this.facialHairColor
        }
      }
      if (this.clotheType !== '0' && this.clotheType !== '1') {
        l = '-l'+this.clotheColor
      }
      if (this.clotheType === '3') {
        m = '-m'+this.graphicType
      }
      return a + b + c + d + e + f + g + h + i + j + k + l + m + n
    }
  },
  mounted () {
    if (this.code) {
      let dec = this.code.split('-')
      dec.forEach(o => {
        switch (o.substr(0, 1)) {
          case 'a':
            this.topType = o.substr(1)
            break
          case 'b':
            this.eyeType = o.substr(1)
            break
          case 'c':
            this.eyebrowType = o.substr(1)
            break
          case 'd':
            this.mouthType = o.substr(1)
            break
          case 'e':
            this.accessoriesType = o.substr(1)
            break
          case 'f':
            this.skinColor = o.substr(1)
            break
          case 'g':
            this.clotheType = o.substr(1)
            break
          case 'h':
            this.hairColor = o.substr(1)
            break
          case 'i':
            this.hatColor = o.substr(1)
            break
          case 'j':
            this.facialHairType = o.substr(1)
            break
          case 'k':
            this.facialHairColor = o.substr(1)
            break
          case 'l':
            this.clotheColor = o.substr(1)
            break
          case 'm':
            this.graphicType = o.substr(1)
            break
          case 'n':
            this.gender = o.substr(1)
            break
        }
      })
    }
  },
  watch: {
    gender (val) {
      if (val === 'F') {
        if (!this.code) {
          this.topType = '24'
        }
      } else {
        if (!this.code) {
          this.topType = '0'
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      this.loading = true,
      this.$axios.patch(`/users/${this.user}/`, { avatar_code: this.codeAvatar })
        .then(resp => {
          this.$store.commit('user/setUser', resp.data)
          this.$emit('update:code', this.codeAvatar)
          this.showMessage(['success', this.$t('success_message.profile_updated')])
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.loading = false
        })

    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
</style>

<i18n>
{
  "en": {
    "customize_avatar": "Customize Avatar",
    "gender": "Gender",
    "hair_hat": "Hair/Hat",
    "hair_color": "Hair color",
    "hat_color": "Hat color",
    "eyes": "Eyes",
    "eyebrows": "Eyebrows",
    "mouth": "Mouth",
    "accessories": "Accessories",
    "facial_hair": "Facial hair",
    "facial_hair_color": "Facial hair color",
    "skin_color": "Skin color",
    "clothe": "Clothe",
    "clothe_color": "Clothe color",
    "graphic_type": "Graphic type"
  },
  "id": {
    "customize_avatar": "Sesuaikan Avatar",
    "gender": "Jenis Kelamin",
    "hair_hat": "Rambut/Topi",
    "hair_color": "Warna Rambut",
    "hat_color": "Warna Topi",
    "eyes": "Mata",
    "eyebrows": "Alis",
    "mouth": "Mulut",
    "accessories": "Aksesoris",
    "facial_hair": "Facial hair",
    "facial_hair_color": "Facial hair color",
    "skin_color": "Warna kulit",
    "clothe": "Pakaian",
    "clothe_color": "Warna pakaian",
    "graphic_type": "Jenis Grafik"
  }
}
</i18n>